import logo from "./logo.svg";
import "./App.css";
import Main from "./component";

function App() {
  return (
    <div className="App bg-[#1a1a1a] p-[10px] sm:p-[54px] min-w-[98vw] min-h-[100vh]">
      <Main />
    </div>
  );
}

export default App;
